
<div class="flow-shimmer" :style="styleObj" />
